'use strict';
import React from 'react';
import {fromJS, Map} from 'immutable';
import {getStoreByName} from 'client/framework';
import {TertiaryHeader} from 'generic/HorizontalNavigationComponent/HorizontalNavigationComponent.react';
import appStore from 'client/AppStore';
import singleStudentStore from './SingleStudent.store';
import LoadingIndicator from 'client/generic/LoadingIndicator.react';
import BlockyDropdown from 'client/generic/BlockyDropdown/BlockyDropdown.react';
import {history} from 'client/history';
import * as SortUtil from 'lib/SortUtil';

import './single-student.scss';

const studentSelectDropdownStore = 'single-student-student-select';

export default class SingleStudentView extends React.Component {
  makeRouteForClassroomStudentList() {
    return `/classes/${appStore.routerProps.params.classId}/students/overview`;
  }

  makeDefaultRouteForStudent(studentId) {
    return `/classes/${appStore.routerProps.params.classId}/students/detail/${studentId}`;
  }

  makeStudentRouteForName(routeName) {
    return `/classes/${appStore.routerProps.params.classId}/students/detail/${appStore.routerProps.params.userId}/${routeName}`;
  }

  makeLinks() {
    return fromJS([
      {
        name: 'Overview',
        to: this.makeStudentRouteForName('overview')
      },
      {
        name: 'Assignments',
        to: this.makeStudentRouteForName('assignments')
      },
      {
        name: 'Topics',
        to: this.makeStudentRouteForName('topics')
      },
      {
        name: 'Info',
        to: this.makeStudentRouteForName('info')
      }
    ]);
  }

  getStudentName() {
    if (!singleStudentStore.hasClassroomData()) {
      return <LoadingIndicator inline={true} />;
    }

    const studentData = singleStudentStore
      .getClassroomData()
      .getStudents()
      .find((student) => student.getId() === appStore.routerProps.params.userId);

    if (!studentData) {
      throw new Error('Unable to find student in classroom');
    }

    return (
      <h2 className='single-student-view__masthead-heading'>{`${studentData.getFirstName()} ${studentData.getLastName()}`}</h2>
    );
  }

  studentDropDownSelectHandler() {
    const dropDownStore = getStoreByName(studentSelectDropdownStore);
    const selectedStudent = dropDownStore.getSelectedItem();

    const studentRoute = this.makeDefaultRouteForStudent(selectedStudent.get('value'));
    history.pushState(null, studentRoute);
  }

  getStudentSelectionDropdown() {
    if (!singleStudentStore.hasClassroomData()) {
      return <LoadingIndicator inline={true} />;
    }

    const studentData = singleStudentStore
      .getClassroomData()
      .getStudents()
      .map((student) => {
        return new Map({
          name: `${student.getLastName()}, ${student.getFirstName()}`,
          lastNameForSorting: student.getLastName() || '',
          value: student.getId()
        });
      })
      .sort((left, right) => {
        return SortUtil.alphaComparatorAscending(
          left.get('lastNameForSorting'),
          right.get('lastNameForSorting')
        );
      });

    const selectedStudent = studentData.find(
      (student) => student.get('value') === appStore.routerProps.params.userId
    );

    return (
      <BlockyDropdown
        storeName={studentSelectDropdownStore}
        displayProperty='name'
        defaultValue={selectedStudent}
        data={studentData}
        onChange={this.studentDropDownSelectHandler.bind(this)}
        resetStoreOnUnmount={false}
      />
    );
  }

  goBackAction = () => {
    history.pushState(null, this.makeRouteForClassroomStudentList());
  };

  render() {
    return (
      <div className='single-student-view'>
        <div className='single-student-view-nav-wrapper'>
          <div className='single-student-view__masthead'>
            <div className='single-student-view__masthead-body'>
              <div className='single-student-view__masthead-item'>
                <div
                  onClick={this.goBackAction}
                  className='single-student-view__masthead-control single-student-view__masthead-control--back'
                >
                  <span className='fa fa-chevron-left' />
                  <span className='single-student-view__masthead-control--arrow-left'>
                    Dashboard
                  </span>
                </div>
              </div>
              <div className='single-student-view__masthead-item'>{this.getStudentName()}</div>
              <div className='single-student-view__masthead-item'>
                <div className='single-student-view__masthead-control'>
                  {this.getStudentSelectionDropdown()}
                </div>
              </div>
            </div>
          </div>
          <div className='single-student-view__tertiary-header'>
            <TertiaryHeader links={this.makeLinks()} disableCommonContentModifier={true} />
          </div>
        </div>
        <div className='single-student-view__content'>
          {this.props.children && React.cloneElement(this.props.children, {})}
        </div>
      </div>
    );
  }
}
